import React from 'react';

interface SectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function Section({ title, children, className = '' }: SectionProps) {
  return (
    <section className={`mb-4 ${className}`}>
      <h2 className="text-sm font-bold uppercase tracking-wider mb-2 pb-1 border-b border-gray-200">
        {title}
      </h2>
      {children}
    </section>
  );
}